export default __webpack_public_path__ + "static/media/over-time.1d46c10d.svg";